import { InstrumentShow } from '@sh4res/bo-common/components/Instruments/InstrumentShow';
import { InstrumentsFundsList } from '@sh4res/bo-common/components/Instruments/InstrumentsFundsList';

import { ResourceDefinition } from '@Utils/types';

export const instrumentsResource: ResourceDefinition = {
  options: { label: 'menu.instruments' },
  list: (props) => <InstrumentsFundsList {...props} testId="BoExternalInstrumentsFundsList" />,
  show: InstrumentShow,
};
